$(document).ready(() => {
  formFocus();
});

export function formFocus(): void {
  const formFocusGenericSelector = 'input[id]:not(:disabled), select[id]:not(:disabled), a[id]:not(:disabled)';
  formFocusSpecific(formFocusGenericSelector);
}

export function formFocusFirstChild(childId: string): void {
  formFocusSpecific(
    '#' + childId + ' input[id]:not(:disabled), #' + childId + ' select[id]:not(:disabled), #' + childId + ' a[id]:not(:disabled)',
  );
}

function formFocusSpecific(selector: string) {
  //figure out which object should be focused (gets the object with the lowest tab index that is enabled.
  const focusObjects = $(selector);

  const withInitialFocusClass = focusObjects.filter('.initialFocus');
  if (withInitialFocusClass.length == 1) {
    withInitialFocusClass.focus();
    return;
  }

  const minFocusObject = findElementToFocus(focusObjects);
  if (minFocusObject) {
    minFocusObject.focus();
  }
}

export function findElementToFocus($focusObjects: JQuery): JQuery | undefined {
  let element: JQuery | undefined = undefined;
  let tabIndex: number;
  $focusObjects.each((_, x) => {
    const currentElement: JQuery = $(x);
    const tabIndexString = currentElement.prop('tabindex');
    if (!tabIndexString) {
      return;
    }
    const currentTabIndex = parseInt(tabIndexString);
    if (currentTabIndex > 0 && (!currentElement.hasClass('data-focus-next') || (currentElement.val() as string).length === 0)) {
      if (!element) {
        element = currentElement;
        tabIndex = currentTabIndex;
      } else if (currentTabIndex < tabIndex) {
        element = currentElement;
        tabIndex = currentTabIndex;
      }
    }
  });

  return element;
}
